import React from 'react';
import PropTypes from 'prop-types';
import { createMuiTheme, ThemeProvider, responsiveFontSizes } from '@material-ui/core/styles';
import CssBaseline from '@material-ui/core/CssBaseline';
import _merge from 'lodash/merge';
import * as Themes from './themes';
import { useBrandingData } from './components/DataProviders';


const DEFAULT_FONT_FAMILY = [
  '-apple-system',
  'BlinkMacSystemFont',
  '"Segoe UI"',
  'Roboto',
  'Oxygen',
  'Ubuntu',
  'Cantarell',
  '"Fira Sans"',
  '"Droid Sans"',
  '"Helvetica Neue"',
  'sans-serif',
];

const DEFAULT_THEME_CONFIG = {
  page: {
    fontFamily: DEFAULT_FONT_FAMILY.join(','),
    '-webkit-font-smoothing': 'antialiased',
    '-moz-osx-font-smoothing': 'grayscale',
  },
  link: {
    textDecoration: 'none',
    '&:hover': {
      textDecoration: 'underline'
    }
  }
};

const DEFAULT_THEME_KEY = 'light';

const muiOverrides = (themeConfig) => ({
  overrides: {
    MuiCssBaseline: {
      '@global': {
        html: {
          minHeight: '100%'
        }
      }
    },
    MuiButtonBase: {
      root: {
        color: (themeConfig.link && themeConfig.link.color) || (themeConfig.main && themeConfig.main.color)
      },
    },
    MuiButton: {
      root: {
        color: (themeConfig.link && themeConfig.link.color) || (themeConfig.main && themeConfig.main.color)
      },
    },
  }
});


export default function Theme({ children, layout }) {
  let theme;
  const { theme_key } = useBrandingData();
  const themeConfig = Themes[theme_key] || Themes[DEFAULT_THEME_KEY];

  try {
    theme = createMuiTheme(
      _merge( {}, DEFAULT_THEME_CONFIG, muiOverrides(themeConfig), themeConfig, layout.themeOverrides )
    );
  }
  catch(_) {
    theme = createMuiTheme(
      DEFAULT_THEME_CONFIG
    );
  }

  theme = responsiveFontSizes(theme);

  return (
    <ThemeProvider theme={theme}>
      <CssBaseline/>
      {children}
    </ThemeProvider>
  );
}

Theme.propTypes = {
  children: PropTypes.node.isRequired,
  layout: PropTypes.func
};
